import {
    Validator
} from 'vee-validate'
import CryptoJS from 'crypto-js'
import Loader from './../shared/loader'
import packingApis from '../../../views/components/packingnew/packingapis.js'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import printpackdata from './printpackdata'
import packingCrossDockComponent from './packingCrossDock'
import moment from 'moment'
import Vue from 'vue';
import apiUrl from '../../../constants';
import axios from 'axios';

export default {
    name: 'Packing',
    components: {
        Loader,
        Multiselect,
        printpackdata,
        packingCrossDockComponent
    },
    data: function () {
        return {
            activeTab: 0,
            showeye1: true,
            filterData: {},
            modalShow: false,
            isLoading: false,
            isLoadingFeild: false,
            css1: true,
            css2: false,
            css3: false,
            showButtonManualPacking: false,
            listWarehouseData: [],
            systemLoginCheck: false,
            showBoxInputs: true,
            showBoxDetails: false,
            showProductQcDetails: false,
            isProductReject: false,
            allowPackingComplete: false,
            rejectReasons: [],
            showInvoiceAndLabels: true,
            options: [],
            token: '',
            showQCAndPackingSection: true,
            showPackingCompleteButton: false,
            showPackdata: false,
            salesChannelList: [],
            showSplitBoxData: false,
            sourceBoxData: [],
            destinationBoxData: [],
            destinationBoxId: '',
            showSplitButton: false,
            destinationProductID: '',
            specialInstructionModel:false,
            specialInstructionList:[],
            specialInstructionCount:0,
            specialInstructionButton:false,
            createBundleModel:false,
            selectedBundleSKU: null,
            bundleProductName:'',
            scanChildSku:'',
            bundleproductid:'',
            bundleitemid:'',
            scanChildSuccess:false,
            scanBundleChildImage:'',
            bundleChildEanCode:'',
            bundleChildProductName:'',
            scanChildClientProductId:'',
            bundleSKUData:[],
            bundleSKUBOMData:[],
            scanTxnqty:0,
            isBundleQtySelect:false,
            isLoadingPacking:false,
            finalObject: {
                warehouseId: '',
                boxId: '',
                boxWeight: 0,
                clientName: '',
                salesChannel: '',
                orderId: '',
                totalSkus: '',
                orderShiByDate: '',
                shipmentId: '',
                productId: '',
                boxStatus: '',
                orderStatus: '',
                clientId: '',
                scanproductData: '',
                rejectReasons: '',
                userEmail: '',
                salesChannelList: [],
                courierName: '',
                awbNo: '',
                showInvoiceButton: false,
                showLabelButton: false,
                normalOrder: false,
                isRubicon: false,
                isWmall: false,
                isUnicommerce: false,
                isMultiseller: false,
                isNimbus: false,
                isincreff:false,
                cancelProductDetails: [],
                orderType: '',
                sellerName: '',
                totalOrderQty: '',
                userId: '',
                shippingLabel: '',
                invoiceLabel: '',
                shippingCode: '',
                orderTypeInput: '',
                shipmentStatus: '',
                merchantName: '',
                xbEcomFlag: false,
                xbEcomAwbNo: '',
                xbEcomCourierCompany: '',
                orderSelfshipped: '',
                productQty: '',
                showQtyInput: false,
                qcQtyPending: '',
                btoborder: '',
                b2b_qc_done: '',
                shippingCourierCompany: null,
                shippingProviderFinal: null,
                issplited:false,
                isdestinationBox:false
            },
            packingbox1:true,
            packingbox:false,
            sugestboxid:'',
            barcodesugestion:'',
            overidereason:'',
            otherreason:'',
            boxchange:false,
            otherreason1:false,
            listPackingBoxData:[],
            packingboxid : '',
            packingboxname:'',
            suggestedpackbox:'',
            packboxchangereason:'',
            packedbox:false,
            productDetails:false,
            productDetail:[],
            finalBoxData:[],
            showSplitBoxPacking:false,
            showBoxSuggestionSplit:false,
            isSuggestionPresent:false,
            isBoxValid:false,
            splitShimentEnable:false,
            issingleQty:false,
            invoiceLabelcall:0,
            hideInvoiceLabel:false,
            hideproceedWithOutSplit:false,
            hideCourierAwbDetails:false,
            hidesplitBoxbtn:false,
            initiatecall : 0 ,
            issuggestionEnabled:false,
            counterFornullvalue:0,
            invoiceFailureReason : '',
            activeTab : 0,
            isReadonlyFlag:1,
            lastShipmentInputTime: Date.now(),
            isScanningForShipment: false,
            scanTimeoutForShipment: null,
        }
    },
    computed: {
        isAllScanned() {
          return this.bundleSKUBOMData.length > 0 && this.bundleSKUBOMData.every((item) => item.bundlescan == item.qty);
        },
      },

    mounted() {
        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key')
        var plaintext = bytes.toString(CryptoJS.enc.Utf8)
        var userdetail = JSON.parse(plaintext)
        var userToken = window.localStorage.getItem('userToken')
        this.token = userToken.replace(/"/g, '')
        this.user_type = userdetail.utype
        this.finalObject.userEmail = userdetail.email
        this.finalObject.userId = userdetail.userid
        this.userid = userdetail.userid
        this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
        if (localStorage.getItem("selectedWarehouse")=="undefined")
        {
            this.$alertify.error(this.$t('common.warehouseError'))
        }
        if (localStorage.getItem("selectedClient")=="undefined")
        {
            this.$alertify.error(this.$t('common.clientError'))
        }
        this.checkEancodeFlag();
        switch (this.user_type) {
            case 'system_user':
                this.systemLoginCheck = true
                // this.getWarehouseList()
                break

            case 'client_user':
                this.$alert(this.$t('common.unauthorisedError'))
                break

            case 'warehouse_user':
                this.finalObject.warehouseId = userdetail.warehouseid
                this.showBoxInputs = true
                break

            default:
                this.$alert(this.$t('common.unauthorisedError'))
                break
        }
    },

    methods: {
    detectKeyPressEventupdate(event) {
        if(this.isReadonlyFlag == 0)
        {
            let currentTime = Date.now();
        // Ignore Enter (13) and Tab (9)
        if (event.keyCode === 13 || event.keyCode === 9) {
            return;
        }

        // First input detected (reset state)
        if (this.lastShipmentInputTime === null) {
            this.lastShipmentInputTime = currentTime;
            this.isScanningForShipment = true; // Assume scanner initially
        }

        let timeDiff = currentTime - this.lastShipmentInputTime;
        // If input is very fast, assume scanner is active
        if (timeDiff <= 50) {
            this.isScanningForShipment = true;
        } else {
            this.isScanningForShipment = false;
        }
        this.lastShipmentInputTime = currentTime;

        // Set a timeout to detect when the scan is complete
        clearTimeout(this.scanTimeoutForShipment);
        
        this.scanTimeoutForShipment = setTimeout(() => {
            if (this.isScanningForShipment && this.finalObject.productId.length > 5) {
            return this.$refs.checkProductid.focus();
            } else {
            this.finalObject.productId = "";
            return this.$alert('Scan the barcode, manual entry not allowed');
            }
        }, 50); // Adjust timing based on your scanner speed
        }
        else{
            return true
        }


    },
        async checkEancodeFlag(){
            let inputPayload = {
                clientid:localStorage.getItem("selectedClient"),
                warehouseid: Number(window.localStorage.getItem("selectedWarehouse")),
            }
                let response = await packingApis.getEancodeFlag(inputPayload, this.token)
                    if (response.data.errorCode == 0) {            
                        if(this.user_type !== 'system_user'){
                            this.isReadonlyFlag = response.data.data.eancodeFlag;
                        }
                    }
                    console.log(this.isReadonlyFlag);
                    
        },
        dateFormatDetail(date) {
            if (!date) return ''
            return moment(date).format('DD-MM-YY HH:mm:ss');
        },
        closeModal() {
            this.modalShow = false
        },
        callParent1() {
            this.showeye1 = true;
        },
        async getPackingBoxFlag(){
            let inputPayload = {
                clientid:Number(this.finalObject.clientId),
            }
            let response = await packingApis.getpackingboxflag(inputPayload, this.token)
            if (response.data.data.ErrorCode == 0) {
                if(response.data.data.data[0].value ==='yes'){
                    this.issuggestionEnabled = true
                     this.getSuggestedPackingDetail()
                 }else{

                    // showSplitBoxPacking && showBoxSuggestionSplit
                    this.issuggestionEnabled = false
                    this.showBoxSuggestionSplit = true;
                    // this.finalObject.issplited =true;
                    if(this.finalObject.issplited){
                        this.showSplitBoxPacking = true
                    }
                 }
            }
        },
        async getPackingBox(){
            let inputPayload = {
            clientid:localStorage.getItem("selectedClient"),
             warehouseid:localStorage.getItem("selectedClient"),
             salesChannel: this.finalObject.salesChannel
            }
                let response = await packingApis.getPackingBox(inputPayload, this.token)
                if (response.data.errorcode == 0) {
                    this.listPackingBoxData = response.data.data;
                }
        },
        
        async splitBoxfun() {
            let splitBoxsData = []
            if (this.destinationBoxData.length == 0) {
                this.$alertify.error(this.$t('packingb2b.destinationBoxErr'))
                return false;
            }
            this.finalBoxData = [...this.sourceBoxData, ...this.destinationBoxData]
            const pushedObjects = {};
            for (let ele of this.finalBoxData) {
                if (pushedObjects[ele.boxid]) {
                    // If the boxid already exists, update the details array
                    pushedObjects[ele.boxid].details.push({
                        productid: ele.productid,
                        clientproductid: ele.clientproductid,
                        quantity: ele.productqty
                    });
                } else {
                    // If the boxid is encountered for the first time, create a new object
                    const newObject = {
                        boxid: ele.boxid,
                        issource: ele.boxid == this.finalObject.boxId ? 1 : 0,
                        details: [{
                            productid: ele.productid,
                            clientproductid: ele.clientproductid,
                            quantity: ele.productqty
                        }]
                    };
                    pushedObjects[ele.boxid] = newObject;
                    splitBoxsData.push(newObject);
                }
            }
            this.isLoading = true
            let inputPayload =
            {
                "clientid": localStorage.getItem("selectedClient"),
                "orderid": this.finalObject.orderId,
                "warehouseid": localStorage.getItem("selectedWarehouse"),
                "useremail": this.finalObject.userEmail,
                "userid": this.finalObject.userId,
                "boxid": this.finalObject.boxId,
                "shipmentid": this.finalObject.shipmentId ? this.finalObject.shipmentId : "",
                "isunicommerce": this.finalObject.isUnicommerce ? 1 : 0,
                "shipmentdetails": splitBoxsData
            }
            let response = await packingApis.splitShipmentGeneric(inputPayload, this.token)
            if (response.data.ErrorCode == 0) {
                this.isLoading = false
                this.showBoxSuggestionSplit = true;
                this.finalObject.issplited =true;
                this.initiatecall = 1
                await this.getPackingBoxFlag()
                if(this.splitShimentEnable && this.finalObject.isUnicommerce){
                    let inputPayload = {
                        warehouseid: localStorage.getItem("selectedWarehouse"),
                        boxid: this.finalObject.boxId,
                        invoiceLabelcall:this.initiatecall
                    }
                    this.isLoading = true
                    let response =   await packingApis.getBoxDetails(inputPayload, this.token)
                    let data = response.data.data.data

                    if (response.data.data.ErrorCode == 0) {
                        this.finalObject.isUnicommerce = data.isUnicommerce
                        this.finalObject.showLabelButton = data.showLabelButton
                        this.finalObject.showInvoiceButton = data.showInvoiceButton
                        this.finalObject.shippingLabel = data.labelUrl
                        this.finalObject.invoiceLabel = data.invoiceUrl
                        this.finalObject.awbNo = data.awbNoPacking
                        this.finalObject.courierName = data.shippingCompany
                        this.finalObject.shipmentId = data.shipmentId
                        this.finalObject.shippingCourierCompany = data.shippingCourierCompany
                        this.finalObject.salesChannelList = []
                        if (data.shippingCourierCompany != null && data.shippingCourierCompany != "-") {
                            this.finalObject.salesChannelList.push({
                                'courierid': this.finalObject.shippingCourierCompany,
                                'couriername': this.finalObject.shippingCourierCompany + "(" + this.finalObject.courierName + ")"
                            });
                            this.finalObject.shippingProviderFinal = this.finalObject.courierName;
                            this.finalObject.courierName = this.finalObject.shippingCourierCompany;
                        } else {
                            this.finalObject.salesChannelList.push({
                                'courierid': this.finalObject.courierName,
                                'couriername': this.finalObject.courierName
                            })
                        }
                        if(this.finalObject.showLabelButton || this.finalObject.showInvoiceButton || this.finalObject.shippingLabel || this.finalObject.invoiceLabel){
                            this.showInvoiceAndLabels = true;
                            this.issingleQty = true
                        }
                        if(!this.finalObject.awbNo || !this.finalObject.courierName){
                            this.$alertify.error(this.$t('packingb2b.awbNoMissing'))
                        }
                        this.isLoading = false
                    }
                    this.isLoading = false
                }
                                this.$alertify.success(response.data.msg)
                
            } else {
                                this.$alertify.error(response.data.data[0].msg)
            }
        },
        
        async getPackingSuggestBox(){
            let inputPayload = ({
             warehouseid: localStorage.getItem("selectedWarehouse"),
             boxid: this.finalObject.boxId,
             clientid:localStorage.getItem("selectedClient")
            });
            let response = await packingApis.getPackingSuggestBox(inputPayload, this.token)
            if (response.data.ErrorCode == 0) {
                this.listPackingBoxData.forEach(e => {
                    if (e.boxname == response.data.data[0].name) {
                         this.sugestboxid = e.boxid;
                       this.packingboxid = e.boxid;
                         this.packingboxname = response.data.data[0].name;
                    }
                })
            }
        },
        async getSuggestedPackingDetail(){
            let inputPayload = ({
             warehouseid: localStorage.getItem("selectedWarehouse"),
             boxid: this.finalObject.boxId,
             clientid:localStorage.getItem("selectedClient")
            });
            let response = await packingApis.getSuggestedPackingDetail(inputPayload, this.token)
            if (response.data.ErrorCode == 0) {
                if(response.data.data[0].packingboxid === null ||response.data.data[0].packingboxid === '' ){
                    await this.getPackingBox();
                    await this.getPackingSuggestBox();
                    this.packingbox = true;
                    this.isSuggestionPresent = false
                    if(!this.finalObject.issplited || this.finalObject.isdestinationBox){
                        this.packingbox1 = false;
                        this.allowPackingComplete = false
                    }else{
                        this.packingbox1 = true;
                    }
                    if( this.splitShimentEnable){
                        this.showSplitBoxPacking = false
                    }
                }else{
                    this.packingbox1 = true;
                    await this.getPackingBox();
                    await this.getPackingSuggestBox();
                    this.packedbox = true;
                    this.isSuggestionPresent = true
                    this.showSplitBoxPacking = true
                   
                    this.listPackingBoxData.forEach(e => {
                        if (e.boxid == response.data.data[0].packingboxid) {
                           this.suggestedpackbox = e.boxname;
                        }
                    })
                    this.packboxchangereason = response.data.data[0].boxchangereason;
                }
            }
        },
        sugestboxidSelected() {
            this.overidereason = '';
            this.otherreason = '';
            if(this.sugestboxid != this.packingboxid){
                this.boxchange = true;
            }else{
                this.boxchange = false;
            }
    },
        overidereasonSelected(){
            if(this.overidereason == 'Other'){
                this.otherreason1 = true;
            }else {
                this.otherreason1 = false;
            }
        },
        barcodesugestionScanned(){
            if(this.barcodesugestion){
                this.listPackingBoxData.forEach(e => {
                    if (e.boxname == this.barcodesugestion) {
                       this.sugestboxid = e.boxid;
                         this.packingboxid = e.boxid;
                    }
                })
            }
        },
        async SaveBoxSugestion(multiSplit = false){
            try {
                let reason = '';
                if(this.sugestboxid){
                    if(this.sugestboxid != this.packingboxid){
            if(this.overidereason == ''){
                            this.$alert(this.$t('boxList.selectOverideReason'))
                            return false
                        }
                        if(this.overidereason == 'Other'){
                            if(this.otherreason == ''){
                                this.$alert(this.$t('boxList.addOverideReason'))
                                return false
              }
                     }
                 }
                }
                if(this.otherreason != ''){
                    reason = this.otherreason;
                }else{
                    reason = this.overidereason;
                }
                let inputPayload = {
                    warehouseid: localStorage.getItem("selectedWarehouse"),
                    boxid: this.finalObject.boxId,
                    clientid:localStorage.getItem("selectedClient"),
                    packingboxid:this.sugestboxid,
                  suggestedpackingbox:this.packingboxid,
                    orderid:this.finalObject.orderId,
                    boxchangereason:reason,
                    useremail:this.finalObject.userEmail,
                    initiateInvoiceLabelcall: this.initiatecall
                }
                this.isLoadingFeild = true
                let response = await packingApis.SaveBoxSugestion(inputPayload, this.token)
                if (response.data.ErrorCode == 0) {
                    this.$alertify.success(this.$t(`apiErrors.${response.data.errorLabel}`));
                    this.getSuggestedPackingDetail()
                    if(!multiSplit){
                        this.getBoxDetails(this.initiatecall)
                        this.addmodalShow = false
                        this.packingbox1 = true;
                    }
                    this.isSuggestionPresent = true
                    this.showSplitBoxPacking =true
                    this.isLoadingFeild = false
                }else{
                    this.$alertify.error(this.$t(`apiErrors.${response.data.errorLabel}`))
                }

            } catch (err) {
                console.log(err)
                this.isLoadingFeild = false
            }

        },
        manualPackingEnable() {
            var checkbox = document.getElementById("manualPackingEnable").checked
            if (checkbox) {
                this.finalObject.salesChannelList = this.salesChannelList
                document.getElementById('awbno').disabled = false
                document.getElementById('couriername').disabled = false
                document.getElementById("manualPackingEnable").disabled = true
                this.showInvoiceAndLabels = false
                this.finalObject.showInvoiceButton = false
                this.finalObject.showLabelButton = false
            }
        },

        // warehouseSelected() {
        //     this.finalObject.boxId = ''
        //     if (this.finalObject.warehouseId) {
        //         this.showBoxInputs = true
        //     }
        // },

        // async getWarehouseList() {
        //     try {
        //         this.isLoading = true
        //         let result = await packingApis.getWarehouseList(this.token)
        //         this.listWarehouseData = result.data.data
        //         this.isLoading = false
        //     } catch (err) {
        //         console.log(err)
        //         this.isLoading = false
        //     }
        // },

        async getWeight() {
            try {
                this.isLoading = true
                let weightResponse = await packingApis.getWeight(this.token)
                this.isLoading = false
                if (weightResponse.status == 200 && weightResponse.data.weight) {
                    this.finalObject.boxWeight = parseFloat(weightResponse.data.weight)
                } else {
                    this.$alert(this.$t('common.weighingMachineError'))
                    this.finalObject.boxWeight = 0
                }
            } catch (err) {
                console.log(err)
                this.isLoading = false
            }
        },
        async getBoxDetails(intiateCall = 1) {
            try {
                if (localStorage.getItem("selectedWarehouse")=="undefined")
                {
                    this.$alertify.error(this.$t('common.warehouseError'))
                }
                if (this.finalObject.boxId < 1) {
                    return false
                }
                this.cleanForm()
                let inputPayload = {
                    warehouseid: localStorage.getItem("selectedWarehouse"),
                    boxid: this.finalObject.boxId,
                    invoiceLabelcall:intiateCall
                }
                let boxId = this.finalObject.boxId
                this.isLoading = true
                let response = await packingApis.getBoxDetails(inputPayload, this.token)
                let data = response.data.data.data
                this.isBundleQtySelect=response.data.data.data.isbundle 
                this.packedbox = false;
                this.packingbox1 = true;
                this.packingbox =false;
                if (response.data.data.ErrorCode == 0) {
                    if(data.iscrossdock == 1){
                        this.$alertify.alert(this.$t('crossDockPacking.crossDockPacking'))
                        .setting({
                            transition:'fade',
                            'message': "<b>" + this.$t('common.boxId') + " : " + boxId + "</b>" + "&nbsp" + this.$t('crossDockPacking.belongstoCrossDock')
                        })
                        this.resetForm();
                        this.isLoading = false;
                        return false;
                    }
                    this.showPackingCompleteButton = true
                    document.getElementById('boxid').disabled = true
                    this.finalObject.merchantName = data.merchantName
                    this.finalObject.clientName = data.clientName
                    this.finalObject.orderId = data.orderId
                    this.finalObject.btoborder = data.btoborder
                    this.finalObject.salesChannel = data.salesChannel
                    this.finalObject.totalSkus = data.totalSkus
                    this.finalObject.totalQty = data.totalQty
                    this.finalObject.totalOrderQty = data.totalOrderQty
                    this.finalObject.cancelQty = data.cancelQty
                    this.finalObject.qtyQcAccept = data.qtyQcAccept
                    this.finalObject.qtyQcReject = data.qtyQcReject
                    this.finalObject.pickqty = data.pickqty
                    this.finalObject.orderShiByDate = data.orderShiByDate
                    this.finalObject.shipmentId = data.shipmentId
                    this.finalObject.boxStatus = data.boxStatus
                    this.finalObject.orderStatus = data.orderStatus
                    this.finalObject.orderSelfshipped = data.orderSelfshipped
                    this.finalObject.clientId = data.clientId
                    this.finalObject.sellerName = data.sellerName
                    this.finalObject.issplited = data.issplited
                    this.finalObject.isdestinationBox = data.isdestinationBox
                    this.finalObject.b2b_qc_done = data.b2b_qc_done
                    this.finalObject.invoicetriggered = data.invoicetriggered
                    this.finalObject.unicommerceOrderDetails = data.unicommerceOrderDetails
                    this.getPackingBoxFlag();
                    await this.splitShipmentEnableOrDisable();
                    await this.checkEancodeFlag();
                    this.initiatecall = (this.splitShimentEnable && !this.issingleQty) ? 0 : 1

                    if (Number(this.finalObject.cancelQty) > 0) {
                        this.finalObject.cancelProductDetails = data.cancelProductDetails
                    }
                    if(this.finalObject.issplited){
                        this.showBoxSuggestionSplit = true
                    }else{
                        this.showBoxSuggestionSplit = false
                    }
                    this.css2 = true
                    this.css1 = false
                    this.showBoxDetails = true
                    this.finalObject.salesChannelList = data.salesChannelList
                    this.salesChannelList = data.salesChannelList
                    this.options = data.rejectQCReasons
                    if ((Number(this.finalObject.qtyQcAccept) + Number(this.finalObject.qtyQcReject) >= Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty)) && Number(this.finalObject.qtyQcReject) > 0 && (this.finalObject.btoborder == 0 || this.finalObject.btoborder == null || this.finalObject.btoborder == '')) {
                        this.showQCAndPackingSection = false
                    } else {
                        this.showQCAndPackingSection = true
                    }
                    if (((Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty) == Number(this.finalObject.qtyQcAccept)) && (this.finalObject.btoborder == 0 || this.finalObject.btoborder == '' || this.finalObject.btoborder == null)) || (this.finalObject.issplited || this.finalObject.isdestinationBox)) {
                        this.allowPackingComplete = true
                    }
                    if ((Number(this.finalObject.qtyQcAccept) + Number(this.finalObject.qtyQcReject) < Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty))){                     
                        this.allowPackingComplete = false

                    }else{
                        this.allowPackingComplete = true
                    }
                        if ((Number(this.finalObject.pickqty) == Number(this.finalObject.qtyQcAccept) + Number(this.finalObject.qtyQcReject)) && this.finalObject.btoborder == 1) {
                        this.allowPackingComplete = true
                        this.showPackingCompleteButton = true
                    }
                    if (this.finalObject.b2b_qc_done == 2 && this.finalObject.btoborder == 1) {
                        this.allowPackingComplete = false
                        this.showPackingCompleteButton = false
                    }

                   
                    this.finalObject.normalOrder = data.normalOrder
                    this.finalObject.isNimbus = data.isNimbus
                    this.finalObject.isRubicon = data.isRubicon
                    this.finalObject.isWmall = data.isWmall
                    this.finalObject.isUnicommerce = data.isUnicommerce
                    this.finalObject.isMultiseller = data.isMultiseller
                    this.finalObject.isincreff = data.isIncreff
                    this.finalObject.xbEcomFlag = data.xbEcomFlag
                    this.finalObject.xbEcomAwbNo = data.xbEcomAwbNo
                    this.finalObject.xbEcomCourierCompany = data.xbEcomCourierCompany
                    this.finalObject.showLabelButton = data.showLabelButton
                    this.finalObject.showInvoiceButton = data.showInvoiceButton
                    this.finalObject.shippingCourierCompany = null;
                    this.finalObject.shippingProviderFinal = null
                    if(this.finalObject.boxStatus == 'in_packing'){
                        this.finalObject.awbNo =data.awbNoPacking;
                        this.finalObject.courierName = data.shippingCompany;
                        if(data.shippingCompany)
                        {
                            this.finalObject.salesChannelList.push({
                                'courierid': data.shippingCompany,
                                'couriername': data.shippingCompany
                            })
                        }
                        document.addEventListener('DOMContentLoaded', function() {
                            document.getElementById('awbno').disabled = true
                            document.getElementById('couriername').disabled = true
                        })              
                    }
                    if (this.finalObject.xbEcomFlag) {
                        this.finalObject.courierName = this.finalObject.xbEcomCourierCompany
                        this.finalObject.salesChannelList = []
                        this.finalObject.salesChannelList.push({
                            'courierid': this.finalObject.xbEcomCourierCompany,
                            'couriername': this.finalObject.xbEcomCourierCompany
                        })
                        this.finalObject.awbNo = this.finalObject.xbEcomAwbNo
                        this.showInvoiceAndLabels = false
                        if (this.finalObject.isRubicon) {
                            this.finalObject.orderTypeInput = 'isRubicon'
                            this.finalObject.orderType = 'Rubicon'
                        } else if (this.finalObject.isWmall) {
                            this.finalObject.orderTypeInput = 'isWmall'
                            this.finalObject.orderType = 'Wmall'
                        } else if (this.finalObject.isMultiseller) {
                            this.finalObject.orderTypeInput = 'isMultiseller'
                            this.finalObject.orderType = 'Flipkart'
                        } else if (this.finalObject.isUnicommerce) {
                            this.finalObject.orderTypeInput = 'isUnicommerce'
                            this.finalObject.orderType = 'Unicommerce'
                        } else {
                            this.finalObject.orderTypeInput = 'isNormal'
                            this.finalObject.orderType = 'CSV'
                        }
                        if((data.invoiceUrl!='' && data.invoiceUrl!=null) ||(data.labelUrl!='' && data.labelUrl!=null))
                        {
                            this.finalObject.shippingLabel = data.labelUrl
                            this.finalObject.invoiceLabel = data.invoiceUrl
                            this.showInvoiceAndLabels = true
                        }
                        if(data.showLabelButton==true || data.showInvoiceButton==true)
                        {
                            this.showInvoiceAndLabels = true
                        }
                        document.addEventListener('DOMContentLoaded', function() {
                        document.getElementById('awbno').disabled = true
                        document.getElementById('couriername').disabled = true
                        })
                    } else if (this.finalObject.isRubicon) {
                        this.showInvoiceAndLabels = true
                        this.finalObject.shippingLabel = data.labelUrl
                        this.finalObject.invoiceLabel = data.invoiceUrl
                        this.finalObject.courierName = data.shippingCompany
                        this.finalObject.salesChannelList = []
                        this.finalObject.salesChannelList.push({
                            'courierid': this.finalObject.courierName,
                            'couriername': this.finalObject.courierName
                        })
                        this.finalObject.awbNo = data.awbNoPacking
                        this.finalObject.orderTypeInput = 'isRubicon'
                        this.finalObject.orderType = 'Rubicon'
                        if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
                            this.showButtonManualPacking = true
                            this.css1 = false
                            this.css2 = false
                            this.css3 = true
                        }
                        if (this.finalObject.courierName != 'Amazon') {
                            document.getElementById('awbno').disabled = true
                        } else {
                            this.finalObject.awbNo = ''
                        }
                        document.getElementById('couriername').disabled = true
                    } else if (this.finalObject.isWmall) {
                        this.showInvoiceAndLabels = true
                        this.finalObject.shippingLabel = data.labelUrl
                        this.finalObject.invoiceLabel = data.invoiceUrl
                        this.finalObject.courierName = data.shippingCompany
                        this.finalObject.salesChannelList = []
                        this.finalObject.salesChannelList.push({
                            'courierid': this.finalObject.courierName,
                            'couriername': this.finalObject.courierName
                        })
                        this.finalObject.awbNo = data.awbNoPacking
                        this.finalObject.orderTypeInput = 'isWmall'
                        this.finalObject.orderType = 'Wmall'
                        if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
                            this.showButtonManualPacking = true
                            this.css1 = false
                            this.css2 = false
                            this.css3 = true
                        }
                        document.getElementById('awbno').disabled = true
                        document.getElementById('couriername').disabled = true
                    } else if (this.finalObject.isMultiseller) {
                        this.showInvoiceAndLabels = true
                        this.finalObject.courierName = data.shippingCompany
                        this.finalObject.salesChannelList = []
                        this.finalObject.salesChannelList.push({
                            'courierid': this.finalObject.courierName,
                            'couriername': this.finalObject.courierName
                        })
                        this.finalObject.awbNo = data.awbNoPacking
                        this.finalObject.shippingLabel = data.labelUrl
                        this.finalObject.invoiceLabel = data.invoiceUrl
                        this.finalObject.orderTypeInput = 'isMultiseller'
                        this.finalObject.orderType = 'Flipkart'
                        if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
                            this.showButtonManualPacking = true
                            this.css1 = false
                            this.css2 = false
                            this.css3 = true
                        }
                        document.getElementById('awbno').disabled = true
                        document.getElementById('couriername').disabled = true
                    } else if (this.finalObject.isUnicommerce) {
                        this.showInvoiceAndLabels = true
                        this.finalObject.courierName = data.shippingCompany
                        this.finalObject.shippingCourierCompany = data.shippingCourierCompany
                        this.finalObject.awbNo = data.awbNoPacking
                        this.finalObject.salesChannelList = []
                        if (data.shippingCourierCompany != null && data.shippingCourierCompany != "-") {
                            this.finalObject.salesChannelList.push({
                                'courierid': this.finalObject.shippingCourierCompany,
                                'couriername': this.finalObject.shippingCourierCompany + "(" + this.finalObject.courierName + ")"
                            });
                            this.finalObject.shippingProviderFinal = this.finalObject.courierName;
                            this.finalObject.courierName = this.finalObject.shippingCourierCompany;
                        } else {
                            this.finalObject.salesChannelList.push({
                                'courierid': this.finalObject.courierName,
                                'couriername': this.finalObject.courierName
                            })
                        }
                        this.finalObject.shippingLabel = data.labelUrl
                        this.finalObject.invoiceLabel = data.invoiceUrl
                        this.finalObject.shippingCode = data.shippingCode
                        this.finalObject.orderTypeInput = 'isUnicommerce'
                        this.finalObject.orderType = 'Unicommerce'
                        if ((!this.finalObject.awbNo || !this.finalObject.courierName || this.finalObject.awbNo=='' || this.finalObject.courierName=='') && data.allowManualPacking) {
                            this.showButtonManualPacking = true
                            this.css1 = false
                            this.css2 = false
                            this.css3 = true
                        }
                        document.addEventListener('DOMContentLoaded', function() {
                            document.getElementById('awbno').disabled = true;
                            document.getElementById('couriername').disabled = true;
                          });
                    } else if (this.finalObject.isNimbus) {
                        this.showInvoiceAndLabels = true
                        this.finalObject.courierName = data.shippingCompany
                        this.finalObject.awbNo = data.awbNoPacking
                        this.finalObject.salesChannelList = []
                        this.finalObject.salesChannelList.push({
                            'courierid': this.finalObject.courierName,
                            'couriername': this.finalObject.courierName
                        })
                        this.finalObject.shippingLabel = data.labelUrl
                        this.finalObject.invoiceLabel = data.invoiceUrl
                        this.finalObject.orderTypeInput = 'isNimbus'
                        this.finalObject.orderType = 'Nimbus'
                        if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
                            this.showButtonManualPacking = true
                            this.css1 = false
                            this.css2 = false
                            this.css3 = true
                        }
                        document.getElementById('awbno').disabled = true
                        document.getElementById('couriername').disabled = true
                    } else if (this.finalObject.normalOrder) {
                        this.finalObject.orderTypeInput = 'isNormal'
                        this.showInvoiceAndLabels = false
                        this.finalObject.orderType = 'CSV'
                        if((data.invoiceUrl!='' && data.invoiceUrl!=null) ||(data.labelUrl!='' && data.labelUrl!=null))
                        {
                            this.finalObject.shippingLabel = data.labelUrl
                            this.finalObject.invoiceLabel = data.invoiceUrl
                            this.showInvoiceAndLabels = true
                        }
                        //alert(this.showInvoiceAndLabels)
                    }
                  else if (!this.finalObject.normalOrder && !this.finalObject.isUnicommerce) {
                        this.finalObject.orderTypeInput = 'isNormal'
                        this.showInvoiceAndLabels = false
                        this.finalObject.orderType = 'CSV'
                        if((data.invoiceUrl!='' && data.invoiceUrl!=null) ||(data.labelUrl!='' && data.labelUrl!=null))
                        {
                            this.finalObject.shippingLabel = data.labelUrl
                            this.finalObject.invoiceLabel = data.invoiceUrl
                            this.showInvoiceAndLabels = true
                        }
                         if(data.nimbusInvoiceAndLabel!=null || data.nimbusInvoiceAndLabel!='')
                        {
                            this.finalObject.shippingLabel = data.nimbusInvoiceAndLabel
                        }
                        if(data.nimbusinvoiceurl!=null || data.nimbusinvoiceurl!='')
                        {
                            this.finalObject.invoiceLabel = data.nimbusinvoiceurl
                        }
                        if(data.showLabelButton==true || data.showInvoiceButton==true)
                        {
                            this.showInvoiceAndLabels = true
                        }
                        if(data.nimbusAwbNo  !=null && data.nimbusAwbNo != "")
                        {
                            this.finalObject.awbNo = data.nimbusAwbNo
                        }
                        if(data.nimbusCourierCompany != null && data.nimbusCourierCompany != "")
                        {
                            this.finalObject.courierName = data.nimbusCourierCompany
                            this.finalObject.salesChannelList.push({
                                'courierid': this.finalObject.courierName,
                                'couriername': this.finalObject.courierName
                            })
                        }
                        //alert(this.showInvoiceAndLabels)
                    } else if (this.finalObject.isincreff) {
                        this.showInvoiceAndLabels = true
                        this.finalObject.courierName = data.shippingCourierCompany
                        this.finalObject.shippingCourierCompany = data.shippingCourierCompany
                        this.finalObject.awbNo = data.awbNoPacking
                        this.finalObject.salesChannelList = []
                        if (data.shippingCourierCompany != null && data.shippingCourierCompany != "-") {
                            this.finalObject.salesChannelList.push({
                                'courierid': this.finalObject.shippingCourierCompany,
                                'couriername': this.finalObject.shippingCourierCompany + "(" + this.finalObject.courierName + ")"
                            });
                            this.finalObject.shippingProviderFinal = this.finalObject.courierName;
                            this.finalObject.courierName = this.finalObject.shippingCourierCompany;
                        } else {
                            this.finalObject.salesChannelList.push({
                                'courierid': this.finalObject.courierName,
                                'couriername': this.finalObject.courierName
                            })
                        }
                        this.finalObject.shippingLabel = data.labelUrl
                        this.finalObject.invoiceLabel = data.invoiceUrl
                        this.finalObject.orderTypeInput = 'isIncreff'
                        this.finalObject.orderType = 'Increff'
                        if ((!this.finalObject.awbNo || !this.finalObject.courierName) && data.allowManualPacking) {
                            this.showButtonManualPacking = true
                            this.css1 = false
                            this.css2 = false
                            this.css3 = true
                        }
                        Vue.nextTick(() => {
                            document.getElementById('awbno').disabled = true
                        document.getElementById('couriername').disabled = true
                        })

                    }
                } else {
                    this.showPackingCompleteButton = false
                    this.showQCAndPackingSection = false
                    this.finalObject.unicommerceOrderDetails = data.unicommerceOrderDetails
                    if (data.isBoxValid) {
                        this.showInvoiceAndLabels = true
                        if(data.nimbusInvoiceAndLabel!=null || data.nimbusInvoiceAndLabel!='')
                        {
                            this.finalObject.shippingLabel = data.nimbusInvoiceAndLabel
                        }
                        if(data.nimbusinvoiceurl!=null || data.nimbusinvoiceurl!='')
                        {
                            this.finalObject.invoiceLabel = data.nimbusinvoiceurl
                        }
                        // alert("2")
                        document.getElementById('boxid').disabled = true
                        this.allowPackingComplete = true
                        this.finalObject.salesChannelList.push({
                            'courierid': data.shippingCompany,
                            'couriername': data.shippingCompany
                        })
                        this.finalObject.courierName = data.shippingCompany
                        this.finalObject.shipmentStatus = data.shipmentStatus
                        this.finalObject.merchantName = data.merchantName
                        this.finalObject.awbNo = data.awbNoPacking
                        this.finalObject.clientName = data.clientName
                        this.finalObject.orderId = data.orderId
                        this.finalObject.btoborder = data.btoborder
                        this.finalObject.salesChannel = data.salesChannel
                        this.finalObject.totalQty = data.totalQty
                        this.finalObject.cancelQty = data.cancelQty
                        if (Number(this.finalObject.cancelQty) > 0) {
                            this.finalObject.cancelProductDetails = data.cancelProductDetails
                        }
                        this.finalObject.totalOrderQty = data.totalOrderQty
                        this.finalObject.orderShiByDate = data.orderShiByDate
                        this.finalObject.shipmentId = data.shipmentId
                        this.finalObject.boxStatus = data.boxStatus
                        this.finalObject.orderStatus = data.orderStatus
                        this.finalObject.orderSelfshipped = data.orderSelfshipped
                        this.finalObject.clientId = data.clientId
                        this.css2 = true
                        this.css1 = false
                        this.showBoxDetails = true
                        this.finalObject.sellerName = data.sellerName
                        this.finalObject.normalOrder = data.normalOrder
                        this.finalObject.isNimbus = data.isNimbus
                        this.finalObject.xbEcomFlag = data.xbEcomFlag
                        this.finalObject.isRubicon = data.isRubicon
                        this.finalObject.isWmall = data.isWmall
                        this.finalObject.isUnicommerce = data.isUnicommerce
                        this.finalObject.isMultiseller = data.isMultiseller
                        this.finalObject.showLabelButton = data.showLabelButton
                        this.finalObject.showInvoiceButton = data.showInvoiceButton
                            this.getPackingBoxFlag();
                            await this.splitShipmentEnableOrDisable();
                            await this.checkEancodeFlag();
                  
                        this.initiatecall = (this.splitShimentEnable && !this.issingleQty) ? 0 : 1   
                        if (this.finalObject.isRubicon) {
                            this.finalObject.orderTypeInput = 'isRubicon'
                            this.finalObject.orderType = 'Rubicon'
                        } else if (this.finalObject.isWmall) {
                            this.finalObject.orderTypeInput = 'isWmall'
                            this.finalObject.orderType = 'Wmall'
                        } else if (this.finalObject.isMultiseller) {
                            this.finalObject.orderTypeInput = 'isMultiseller'
                            this.finalObject.orderType = 'Flipkart'
                        } else if (this.finalObject.isUnicommerce) {
                            this.finalObject.orderTypeInput = 'isUnicommerce'
                            this.finalObject.orderType = 'Unicommerce'
                        } else if (this.finalObject.isNimbus) {
                            this.finalObject.shippingLabel = data.labelUrl
                            this.finalObject.invoiceLabel = data.invoiceUrl
                            this.finalObject.orderTypeInput = 'isNimbus'
                            this.finalObject.orderType = 'Nimbus'
                        } else if (this.finalObject.normalOrder) {
                            this.finalObject.orderTypeInput = 'isNormal'
                            this.finalObject.orderType = 'CSV'
                        } else if (this.finalObject.isincreff) {
                            this.finalObject.orderTypeInput = 'isIncreff'
                            this.finalObject.orderType = 'Increff'
                        }


                    } else {
                        this.showInvoiceAndLabels = false
                        document.getElementById('boxid').value = null
                        this.finalObject.boxId = ""
                    }
                    //if (this.finalObject.b2b_qc_done == 2  && this.finalObject.btoborder == 1 ) {
                    //      this.showPackingCompleteButton = false
                    //}
                    if ((this.finalObject.orderStatus == 'packed' ||  this.finalObject.orderStatus =='dispatched' || this.finalObject.orderStatus == 'sr' || this.finalObject.orderStatus == 'rto')&& this.finalObject.btoborder == 1 && this.finalObject.btoborder != '') {
                        this.showPackdata = true
                    }

                    let errMessage = response.data.data.errorLabel
					const str = errMessage.split(/[{}]/)
						.map(part => (!this.$t(`apiErrors.${part}`) || this.$t(`apiErrors.${part}`).startsWith("apiErrors")) ? part : this.$t(`apiErrors.${part}`))
						.join(" ");
					this.$alert(str, boxId)

                    if((this.finalObject.orderStatus == 'packed' || this.finalObject.orderStatus =='dispatched' ||this.finalObject.orderStatus == 'sr' || this.finalObject.orderStatus == 'rto') && this.finalObject.btoborder == 0 ){
                         this.hideCourierAwbDetails= true
                         this.splitShimentEnable = false 
                         this.issingleQty = false
                         this.allowPackingComplete= false
                         this.hidesplitBoxbtn=true
                         this.hideproceedWithOutSplit = true
                     }
                    errMessage = response.data.data.errorLabel  
					const errStr = errMessage.split(/[{}]/)
						.map(part => (!this.$t(`apiErrors.${part}`) || this.$t(`apiErrors.${part}`).startsWith("apiErrors")) ? part : this.$t(`apiErrors.${part}`))
						.join(" ");
                        this.$alert(errMessage!=''?errMessage:response.data.data.msg, boxId)
                }
                if (this.splitShimentEnable && this.finalObject.orderType !== 'CSV') {
                    this.finalObject.showLabelButton = false;
                    this.finalObject.showInvoiceButton = false;
                    this.showInvoiceAndLabels = false;
                    this.hideInvoiceLabel = true;
                    this.hideCourierAwbDetails = true;
                    
                    if (Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty) > 1) {
                      this.issingleQty = false;
                    } else {
                      this.issingleQty = true;
                    }
                    
                    this.showButtonManualPacking = false;
                  }
                  
                  if (this.finalObject.issplited || this.finalObject.isdestinationBox) {
                    this.showPackingCompleteButton = true;
                    this.showQCAndPackingSection = true;
                    // this.packingbox1 = false;
                    // this.allowPackingComplete = false
                }
                const validStatuses = ['packed', 'sr', 'rto', 'cancelled','dispatched'];
                if (((validStatuses.includes(this.finalObject.orderStatus) &&  this.finalObject.boxStatus === 'in_shipping')) || (this.finalObject.boxStatus === 'cancelled' || this.finalObject.orderStatus === 'cancelled')) {                   
                    this.showPackingCompleteButton = false;
                    this.showQCAndPackingSection = false;
                    this.issuggestionEnabled = false
                    if(this.finalObject.invoiceLabel || this.finalObject.shippingLabel){
                        this.finalObject.invoicetriggered = true
                    }
                }
                  if(!this.showPackingCompleteButton && !this.showQCAndPackingSection ){
                    this.issingleQty = true
                  }
                  if (this.splitShimentEnable  && this.finalObject.invoicetriggered && this.finalObject.orderType !== 'CSV' && ((this.finalObject.shippingLabel || this.finalObject.invoiceLabel) || (data.showLabelButton || data.showInvoiceButton))) {
                    this.showInvoiceAndLabels = true;
                    this.finalObject.showInvoiceButton = true;
                    this.finalObject.showLabelButton = true;
                    this.issingleQty = true;
                    this.hideproceedWithOutSplit = true;
                    this.hideCourierAwbDetails = false;
                    this.hidesplitBoxbtn = true;
                  }
                  if (this.finalObject.orderType !== 'CSV' && (!this.finalObject.shippingLabel || !this.finalObject.invoiceLabel) && this.finalObject.unicommerceOrderDetails &&
                  !this.finalObject.unicommerceOrderDetails.status) {
                    this.invoiceFailureReason = this.finalObject.unicommerceOrderDetails.msg
                    this.$alert("UnicommerceDetails error : "+this.invoiceFailureReason)
                }
                  if (this.finalObject.issplited && this.finalObject.invoicetriggered) {
                    this.hidesplitBoxbtn = false;
                    this.hideCourierAwbDetails = true;
                  }       
                  // below commented code was added if awbNo or courierName not fetching for first call but this doesnt work since
                  //uniware take some time to process it and does not return data by again calling getboxdetails..

                //   if((!this.finalObject.awbNo || !this.finalObject.courierName) && this.finalObject.isunicommerce && (intiateCall == 1 || this.finalObject.totalQty == 1) && this.counterFornullvalue < 1 && this.finalObject.isdestinationBox && this.splitShimentEnable){
                //     this.getBoxDetails(1)
                //     this.counterFornullvalue = 1
                //    }
                  if (intiateCall === 2) {
                    this.showSplitBoxData = true;
                    this.showSplitButton = false;
                  }

                this.isLoading = false

            } catch (err) {
                console.log(err)
                this.isLoading = false
            }
            finally{ 
                if(this.finalObject.salesChannel!==""){
                    this.getSpecialInstruction()
                }
            }
        },

        cleanForm() {
            this.isLoading = false
            this.isLoadingFeild = false
            this.salesChannelList = []
            this.css1 = true
            this.css2 = false
            this.css3 = false
            this.showButtonManualPacking = false
            this.showBoxDetails = false
            this.showProductQcDetails = false
            this.isProductReject = false
            this.allowPackingComplete = false
            this.qcdone = false
            this.rejectReasons = []
            this.showInvoiceAndLabels = true
            this.options = []
            this.showPackingCompleteButton = false
            this.showQCAndPackingSection = false
            this.finalObject.boxWeight = 0
            this.finalObject.clientName = ''
            this.finalObject.salesChannel = ''
            this.finalObject.orderId = ''
            this.finalObject.totalSkus = ''
            this.finalObject.orderShiByDate = ''
            this.finalObject.shipmentId = ''
            this.finalObject.productId = ''
            this.finalObject.productQty = ''
            this.finalObject.showQtyInput = false
            this.finalObject.qcQtyPending = ''
            this.finalObject.boxStatus = ''
            this.finalObject.orderStatus = ''
            this.finalObject.clientId = ''
            this.finalObject.scanproductData = ''
            this.finalObject.rejectReasons = ''
            this.finalObject.salesChannelList = []
            this.finalObject.courierName = ''
            this.finalObject.awbNo = ''
            this.finalObject.showInvoiceButton = false
            this.finalObject.showLabelButton = false
            this.finalObject.normalOrder = false
            this.finalObject.isNimbus = false
            this.finalObject.isRubicon = false
            this.finalObject.isWmall = false
            this.finalObject.isUnicommerce = false
            this.finalObject.isMultiseller = false
            this.finalObject.cancelProductDetails = []
            this.finalObject.orderType = ''
            this.finalObject.sellerName = ''
            this.finalObject.totalOrderQty = ''
            this.finalObject.shippingLabel = ''
            this.finalObject.invoiceLabel = ''
            this.finalObject.shippingCode = ''
            this.finalObject.orderTypeInput = ''
            this.finalObject.shipmentStatus = ''
            this.finalObject.merchantName = ''
            this.showSplitBoxData = false
            this.destinationBoxId = ''
            this.destinationProductID = ''
            this.showSplitButton = false
            this.finalObject.orderSelfshipped = ''
            this.otherreason1 = false;
            this.boxchange = false;
            this.packedbox = false;
            this.packingbox1 =true;
            this.packingbox =false;
            this.overidereason = '';
            this.otherreason = '';
            this.splitShimentEnable = false;
            this.hideproceedWithOutSplit = false;
            this.issingleQty = false,
            this.invoiceLabelcall = 0,
            this.hideInvoiceLabel = false,
            this.hideproceedWithOutSplit = false,
            this.hideCourierAwbDetails = false,
            this.hidesplitBoxbtn = false,
            this.initiatecall = 0,
            this.showQCAndPackingSection= true,
            this.showPackingCompleteButton= false
        },

        resetForm() {
            if (this.systemLoginCheck) {
                this.finalObject.warehouseId = ''
                this.$validator.reset()
            }
            this.packedbox = false;
            this.packingbox1 =true;
            this.packingbox =false;
            this.overidereason = '';
            this.otherreason = '';
            this.finalObject.xbEcomFlag = ''
            this.finalObject.xbEcomAwbNo = ''
            this.finalObject.xbEcomCourierCompany = false
            this.showSplitBoxData = false
            this.sourceBoxData = []
            this.destinationBoxData = []
            this.destinationBoxId = ''
            this.showSplitButton = false
            this.destinationProductID = ''
            this.isLoading = false
            this.isLoadingFeild = false
            this.salesChannelList = []
            this.css1 = true
            this.css2 = false
            this.css3 = false
            this.showButtonManualPacking = false
            this.showBoxDetails = false
            this.showProductQcDetails = false
            this.isProductReject = false
            this.allowPackingComplete = false
            this.rejectReasons = []
            this.showInvoiceAndLabels = true
            this.options = []
            this.showPackingCompleteButton = false
            this.showQCAndPackingSection = false
            this.finalObject.boxId = ''
            this.finalObject.boxWeight = 0
            this.finalObject.clientName = ''
            this.finalObject.salesChannel = ''
            this.finalObject.orderId = ''
            this.finalObject.totalSkus = ''
            this.finalObject.orderShiByDate = ''
            this.finalObject.shipmentId = ''
            this.finalObject.productId = ''
            this.finalObject.productQty = ''
            this.finalObject.showQtyInput = false
            this.finalObject.qcQtyPending = ''
            this.finalObject.boxStatus = ''
            this.finalObject.orderStatus = ''
            this.finalObject.clientId = ''
            this.finalObject.scanproductData = ''
            this.finalObject.rejectReasons = ''
            this.finalObject.salesChannelList = []
            this.finalObject.courierName = ''
            this.finalObject.awbNo = ''
            this.finalObject.showInvoiceButton = false
            this.finalObject.showLabelButton = false
            this.finalObject.normalOrder = false
            this.finalObject.isNimbus = false
            this.finalObject.isRubicon = false
            this.finalObject.isWmall = false
            this.finalObject.isUnicommerce = false
            this.finalObject.isMultiseller = false
            this.finalObject.cancelProductDetails = []
            this.finalObject.orderType = ''
            this.finalObject.sellerName = ''
            this.finalObject.totalOrderQty = ''
            this.finalObject.shippingLabel = ''
            this.finalObject.invoiceLabel = ''
            this.finalObject.shippingCode = ''
            this.finalObject.orderTypeInput = ''
            this.finalObject.shipmentStatus = ''
            this.finalObject.merchantName = ''
            this.finalObject.orderSelfshipped = ''
            this.finalBoxData=[],
            this.isSuggestionPresent=false
            this.isBoxValid = false,
            this.splitShimentEnable = false,
            this.hideproceedWithOutSplit = false;
            this.issingleQty = false,
            this.invoiceLabelcall = 0,
            this.hideInvoiceLabel = false,
            this.hideproceedWithOutSplit = false,
            this.hideCourierAwbDetails = false,
            this.hidesplitBoxbtn = false,
            this.initiatecall = 0
            document.getElementById('boxid').value = null
            document.getElementById('boxid').disabled = false
            document.getElementById('productid').disabled = false
            document.getElementById('productid').value = false
            document.getElementById('awbno').disabled = false
            document.getElementById('awbno').value = false
            document.getElementById('couriername').disabled = false
            document.getElementById('couriername').value = false
            document.getElementById("manualPackingEnable").disabled = false
            document.getElementById('destinationBoxId').value = null
            document.getElementById('destinationBoxId').disabled = false
            this.otherreason1 = false;
            this.boxchange = false;
            this.$validator.reset()
        },
        async splitShipmentEnableOrDisable() {
            return new Promise((resolve, reject) => {
              var userToken = window.localStorage.getItem('userToken');
              var myStr = userToken.replace(/"/g, '');
              var input = {
                localclientid: localStorage.getItem("selectedClient"),
                warehouseidlocal: ''
              };
              axios({
                method: "post",
                url: apiUrl.api_url + "getconfig",
                data: input,
                headers: {
                  'Authorization': 'Bearer ' + myStr,
                },
              })
              .then((response) => {
                if (response.status == 200) {
                  var result = response.data;
                  for (var i = 0; i < result.length; i++) {
                    if (result[i].type == "split_box") {
                      if (!result[i].value || result[i].value == "no") {
                        this.splitShimentEnable = false
                    } else {
                        this.splitShimentEnable = true
                    }
                    }
                  }
                  resolve(1); // Resolve the promise once the function completes successfully
                } else {
                  this.$alertify.error(this.$t('common.configDetailsNotfoundErr'));
                  reject(new Error("Config Details Not Found")); // Reject the promise with an error
                }
              })
              .catch((error) => {
                reject(error); // Reject the promise with the caught error
              });
            });
          },

        async scanProduct(action=0,quantity = 1,isSplit = 0) {
            try {
                this.isProductReject = false
                this.showProductQcDetails = false
                this.finalObject.productQty = ''
                this.finalObject.showQtyInput = false
                this.finalObject.qcQtyPending = ''
                if (!this.finalObject.productId) {
                    this.$alert(this.$t('common.productIdPlaceHolder'))
                }
                if(!this.isBoxValid && isSplit == 1){
                    this.$alert(this.$t('packingb2b.validateBox'))
                    return false;
                }
                if (Number(this.destinationBoxId) == Number(this.finalObject.boxId)) {
					this.$alert(this.$t('boxList.boxIDError'), this.destinationBoxId)
					this.destinationBoxId = ''
					document.getElementById('destinationBoxId').value = null
					return false
				}
                let inputPayload = {
                    warehouseid: localStorage.getItem("selectedWarehouse"),
                    boxid: this.finalObject.boxId,
                    clientid: localStorage.getItem("selectedClient"),
                    orderid: this.finalObject.orderId,
                    productid: this.finalObject.productId.trim()
                }
                this.isLoadingFeild = true
                let response = await packingApis.scanProductPacking(inputPayload, this.token,isSplit)
                let data = response.data.data.data
                let productId = this.finalObject.productId.trim()
                this.productDetail=[]
                if(response.data.ErrorCode == 0 && isSplit ==1){
                    this.productDetail.push({
                        "productid":response.data.data[0].productid || "",
                        "ean":response.data.data[0].eancode || "",
                        "color":response.data.data[0].color,
                        "brand":response.data.data[0].brand,
                        "size":response.data.data[0].size,
                        "productname":response.data.data[0].productname,
                        "productimage": response.data.data[0].productimage || ""
                    })
                    this.showProductQcDetails = true
                    this.productDetails = true;
                    this.addRemoveProductqty(action,quantity,response.data.data[0].eancode)
                    this.finalObject.productId='';
                    this.isLoadingFeild = false
                    return true;
                }else if(response.data.ErrorCode == -1 && isSplit ==1){
                    this.$alert(response.data.msg)
                    this.isLoadingFeild = false
                    this.finalObject.productId='';
                    this.productDetails=false;
                    return false;
                }

                if (response.data.data.ErrorCode == 0 && isSplit == 0) {
                    console.log("=============1260==========");
                    this.finalObject.scanproductData = response.data.data.data   
                    this.showProductQcDetails = true
                    document.getElementById('productid').disabled = true
                    if (response.data.data.data.resultConfigBulkPickingPacking.status && Number(response.data.data.data.qcQtyPending) >= Number(response.data.data.data.resultConfigBulkPickingPacking.limit)) {
                        this.finalObject.showQtyInput = true
                        this.finalObject.qcQtyPending = Number(response.data.data.data.qcQtyPending)
                    }
                } else {
                    console.log("-----------1268------------");
                    this.finalObject.qcQtyPending = ''
                    this.finalObject.productId = ''
                    this.finalObject.productQty = ''
                    this.finalObject.showQtyInput = false
                    let errMessage = response.data.data.errorLabel
					const str = errMessage.split(/[{}]/)
						.map(part => (!this.$t(`apiErrors.${part}`) || this.$t(`apiErrors.${part}`).startsWith("apiErrors")) ? part : this.$t(`apiErrors.${part}`))
						.join(" ");
					this.$alert(str!=''?str:response.data.data.msg, productId)
                    document.getElementById('productid').disabled = false
                }
                this.isLoadingFeild = false
            } catch (err) {
                console.log(err)
                this.isLoadingFeild = false
            }
        },

        addRemoveProductqty(action=0,quantity=1,eancode=''){
            if(!this.destinationBoxId){      
                this.$alert(this.$t('boxList.DestinationBoxiderr'))
                return false;
            }
            const totalQuantity = this.sourceBoxData.reduce((acc,item)=>{
                 return acc + item.productqty
            },0);
            const index = this.sourceBoxData.findIndex(item => (item.productid == this.finalObject.productId || item.eancode == eancode));
            const destinationindex = this.destinationBoxData.findIndex(item => (item.productid == this.finalObject.productId || item.eancode == eancode) && item.boxid == this.destinationBoxId);
            if(index == -1 && action==0){
                this.$alert(this.$t('boxList.sourceBoxerr'))
                return false;
            }else if(destinationindex == -1 && action==1){
                this.$alert(this.$t('boxList.destinationBoxerr'))
                return false;
            }
            if(index !== -1 && totalQuantity <=1 && action == 0){
                this.$alert(this.$t('boxList.sourceBoxvalidation'))
                return false;
            }
            if(index !== -1 && this.sourceBoxData[index].productqty < quantity && action == 0){
                this.$alert(this.$t('boxList.productqtyErr'))
                return false;
            }

            if(destinationindex !== -1 && this.destinationBoxData[destinationindex].productqty < quantity && action == 1){
                this.$alert(this.$t('boxList.productqtyErr'))
                return false;
            }
            
         
            // If the object is found and the quantity is valid
            if (action == 0 &&  index !== -1 && quantity > 0 && quantity <= this.sourceBoxData[index].productqty) {
            // Update the quantity in array1 and add a new object to array2
            this.sourceBoxData[index].productqty -= quantity;
            if(destinationindex == -1){
            this.destinationBoxData.push({ productid:this.sourceBoxData[index].productid,
                 productqty:quantity,
                 eancode: this.sourceBoxData[index].eancode,
                 boxid:this.destinationBoxId,
                 clientproductid:this.sourceBoxData[index].clientproductid,
                });
                if(this.sourceBoxData[index].productqty == 0){
                    this.sourceBoxData.splice(index, 1); 
                }
            }else{
                this.destinationBoxData[destinationindex].productqty = this.destinationBoxData[destinationindex].productqty + 1;
                if (this.sourceBoxData[index].productqty == 0) {
                    this.sourceBoxData.splice(index, 1);
                }
            }
            this.$alert(this.$t('boxList.productqtyAlert'))
            return true;
            } 
            else if(action == 1 && destinationindex !== -1 && quantity > 0 && quantity <= this.destinationBoxData[destinationindex].productqty){
                this.destinationBoxData[destinationindex].productqty = this.destinationBoxData[destinationindex].productqty - quantity;
              if(index == -1){
                this.sourceBoxData.push({ productid:this.destinationBoxData[destinationindex].productid,
                    productqty:quantity,
                    eancode:  this.destinationBoxData[destinationindex].eancode,
                    clientproductid:  this.destinationBoxData[destinationindex].clientproductid,
                    boxid:this.destinationBoxId
                   }); 
                    if (this.destinationBoxData[destinationindex].productqty == 0) {
                        this.destinationBoxData.splice(destinationindex, 1);
                    }
              }else{
                this.sourceBoxData[index].productqty = this.sourceBoxData[index].productqty + 1;
                if (this.destinationBoxData[destinationindex].productqty == 0) {
                    this.destinationBoxData.splice(destinationindex, 1);
                }
              }
              this.$alert(this.$t('boxList.productqtyAlert'))
              return true
            }else{
                this.$alert(this.$t('boxList.validateboxid'))
                return false;
            }
        },

        productQC(obj) {
            if (obj == "reject") {
                this.isProductReject = true
            } else {
                this.updateQcDetails(obj)
            }
        },
        async qcDone() {
            this.modalShow = true
        },
        PrintPackdata(data) {
            this.selectedRow = data
            this.showeye1 = false;
        },
        async changeBoxStatus() {
            try {
                let inputPayload = {
                    warehouseid: localStorage.getItem("selectedWarehouse"),
                    boxid: this.finalObject.boxId,
                    clientid: localStorage.getItem("selectedClient"),
                    orderid: this.finalObject.orderId,
                }
                this.isLoadingFeild = true
                let response = await packingApis.changeBoxStatus(inputPayload, this.token)
                //let data = response.data.data.data
                //  console.log(response.data)
                if (response.data.msg == 1) {
                    this.$alertify.success(this.$t('boxList.boxStatusUpdate'))
                    this.addmodalShow = false
                    this.getBoxDetails(this.initiatecall)

                }


            } catch (err) {
                console.log(err)
                this.isLoadingFeild = false
            }
        },

        async updateQcDetails(obj) {
            try {
                if (obj == 'reject' && this.finalObject.rejectReasons.length < 1) {
                    this.$alert(this.$t('boxList.rejectReasonError'))
                    return false
                }
                if (this.finalObject.showQtyInput && Number(this.finalObject.qcQtyPending) != Number(this.finalObject.productQty)) {
                    if (Number(this.finalObject.qcQtyPending) > Number(this.finalObject.productQty)) {
                        this.$alert(this.$t('boxList.pickedQtyLessError'))
                    } else {
                        this.$alert(this.$t('boxList.pickedQtyGreaterError'))
                    }
                    return false
                }
                //  alert(this.finalOpbject.warehouseId)
                let inputPayload = {
                    warehouseid: localStorage.getItem("selectedWarehouse"),
                    boxid: this.finalObject.boxId,
                    clientid: localStorage.getItem("selectedClient"),
                    orderid: this.finalObject.orderId,
                    productid: this.finalObject.productId.trim(),
                    qcstatus: obj,
                    rejectreasons: obj == "reject" ? this.finalObject.rejectReasons : [],
                    useremail: this.finalObject.userEmail,
                    productqty: this.finalObject.showQtyInput ? this.finalObject.productQty : '',
                    btoborder: this.finalObject.btoborder,
                }
                this.isLoadingFeild = true
                let response = await packingApis.updateQcDetails(inputPayload, this.token)
                let data = response.data.data.data
                if (response.data.data.ErrorCode == 0) {
                    this.finalObject.rejectReasons = []
                    this.rejectReasons = []
                    this.finalObject.productId = ''
                    this.finalObject.productQty = ''
                    this.finalObject.showQtyInput = false
                    this.finalObject.qcQtyPending = ''
                    this.finalObject.scanproductData = {}
                    this.finalObject.qtyQcAccept = data.totalQCAcceptQty
                    this.finalObject.qtyQcReject = data.totalQCRejectQty
                    this.isProductReject = false
                    this.showProductQcDetails = false
                    if ((Number(this.finalObject.qtyQcAccept) + Number(this.finalObject.qtyQcReject) >= Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty)) && Number(this.finalObject.qtyQcReject) > 0) {
                        this.showQCAndPackingSection = false
                    } else {
                        this.showQCAndPackingSection = true
                    }
                    if ((Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty) == Number(this.finalObject.qtyQcAccept)) && (this.finalObject.btoborder == 0 || this.finalObject.btoborder == null || this.finalObject.btoborder == '')) {
                        this.allowPackingComplete = true
                        this.showPackingCompleteButton = true
                        if (this.finalObject.isRubicon || this.finalObject.isWmall || this.finalObject.isMultiseller || this.finalObject.isUnicommerce) {
                            document.getElementById('awbno').disabled = true
                            if (this.finalObject.courierName == 'Amazon' && this.finalObject.isRubicon) {
                                document.getElementById('awbno').disabled = false
                                this.finalObject.awbNo = ''
                            }
                            document.getElementById('couriername').disabled = true
                        }
                    }
                    if ((Number(this.finalObject.pickqty) == Number(this.finalObject.qtyQcAccept) + Number(this.finalObject.qtyQcReject)) && this.btoborder == 1) {
                        this.allowPackingComplete = true
                        this.showPackingCompleteButton = true
                    }

                    this.$alertify.success(this.$t(`apiErrors.${response.data.data.errorLabel}`))
                    document.getElementById('productid').disabled = false
                    this.getBoxDetails(this.initiatecall);

                } else {
                    let errMessage = response.data.data.errorLabel
					const str = errMessage.split(/[{}]/)
						.map(part => (!this.$t(`apiErrors.${part}`) || this.$t(`apiErrors.${part}`).startsWith("apiErrors")) ? part : this.$t(`apiErrors.${part}`))
						.join(" ");
                    this.$alert(str!=''?str:response.data.data.msg, this.finalObject.productId.trim())
                    document.getElementById('productid').disabled = false
                    return false
                }
                this.isLoadingFeild = false
            } catch (err) {
                console.log(err)
                this.isLoadingFeild = false
            }
        },

        rejectedReasonsSelected() {
            let isOther = this.rejectReasons.map(el => el.value).includes("Other")
            if (isOther) {
                this.$prompt(this.$t('rejectreason.rejectReasonPlaceHolder')).then(text => {
                    if (text && text != '' && text != null) {
                        this.rejectReasons.push({
                            value: text.trim(),
                            text: text.trim()
                        })
                        this.$alert(this.$t('boxList.rejectReasonMsg1'), text)
                    } else {
                        this.$alert(this.$t('boxList.rejectReasonMsg2'), text)
                    }
                })
            }
            this.finalObject.rejectReasons = this.rejectReasons.map(el => el.value)
        },

        completePacking() {
            if(this.finalObject.awbNo.indexOf(' ') >= 0)
            {
                this.$alert(this.$t('common.awbError'))
                return false;
            }

            if (!this.finalObject.awbNo || !this.finalObject.courierName) {
                this.$validator.validateAll()
                return false
            } else {
                if (Number(this.finalObject.cancelQty) > 0) {
                    this.$confirm(this.$t('boxList.rackinProducts')).then((confirm) => {
                        if (confirm) {
                            this.completeBoxPacking()
                        }
                    })
                } else {
                    this.completeBoxPacking()
                }
            }
        },

        async printInvoice() {
            try {
                if (this.finalObject.isRubicon) {
                    this.isLoading = true
                    let inputPayload = {
                        clientid: localStorage.getItem("selectedClient"),
                        shipmentid: this.finalObject.shipmentId,
                        orderid: this.finalObject.orderId,
                        sellername: this.finalObject.sellerName
                    }
                    let result = await packingApis.getrubiconInvoiceAndLabel(inputPayload, this.token)
                    if (result.data.data.ErrorCode == 0) {
                        if (result.data.data.data.invoice_document_external_url) {
                            this.windowOpen(result.data.data.data.invoice_document_external_url)
                        } else {
                            //this.$alert(result.data.data.msg)
                            this.$alert(this.$t(`apiErrors.${result.data.data.errorLabel}`))

                        }
                    } else {
                        //this.$alert(result.data.data.msg)
                        this.$alert(this.$t(`apiErrors.${result.data.data.errorLabel}`))
                    }
                    this.isLoading = false
                } else if (this.finalObject.isUnicommerce) {
                    if (this.showPackingCompleteButton) {
                        if(!this.finalObject.invoiceLabel){
                            this.$alert(this.invoiceFailureReason ? "Unable to retrieve the Uniware Invoice." + this.invoiceFailureReason : "Unable to retrieve the Uniware Invoice")
                            return false
                         }
                        //this.windowOpen(this.finalObject.invoiceLabel)
                        //alert("hi2")
                        //window.open("data:application/pdf;base64, " + this.finalObject.invoiceLabel);
                        //  let newdata = "data:application/pdf;base64, " + this.finalObject.invoiceLabel;
                        var newWindow = window.open();
                        newWindow.document.write('<iframe src="data:application/pdf;base64,' + (this.finalObject.invoiceLabel) + '" width="100%" height="600px" frameborder="0" allowfullscreen></iframe>');
                        newWindow.document.title = "Invoice-" + this.finalObject.orderId;


                    } else {
                        this.isLoading = true
                        let inputPayload = {
                            clientid: localStorage.getItem("selectedClient"),
                            warehouseid: localStorage.getItem("selectedWarehouse"),
                            orderid: this.finalObject.orderId,
                            shipmentid: this.finalObject.shipmentId,
                            saleschannel: this.finalObject.salesChannel //passed sales channel
                        }
                        let result = await packingApis.getUnicommerceInvoiceAndLabel(inputPayload, this.token)
                        if (result.data.data.ErrorCode == 0) {
                            var newWindow = window.open();
                            newWindow.document.write('<iframe src="data:application/pdf;base64,' + (result.data.data.data.data.invoicelabel) + '" width="100%" height="600px" frameborder="0" allowfullscreen></iframe>');
                            newWindow.document.title = "Invoice-" + this.finalObject.orderId;
                        } else {
                            this.$alert(result.data.data.msg)
                        }
                        this.isLoading = false
                    }
                } else if (this.finalObject.isMultiseller) {
                    if (this.showPackingCompleteButton) {
                        this.getInvoiceAndLabelFlipkart(1)
                    } else {
                        this.isLoading = true
                        let inputPayload = {
                            clientid: localStorage.getItem("selectedClient"),
                            warehouseid: localStorage.getItem("selectedWarehouse"),
                            shipmentid: this.finalObject.shipmentId,
                            orderid: this.finalObject.orderId
                        }
                        let result = await packingApis.getFlipkartInvoiceAndLabel(inputPayload, this.token)
                        if (result.data.data.ErrorCode == 0) {
                            this.finalObject.shippingLabel = result.data.data.data.data
                            this.finalObject.invoiceLabel = result.data.data.data.data
                            this.getInvoiceAndLabelFlipkart(1)
                        } else {
                            this.$alert(result.data.data.msg)
                        }
                        this.isLoading = false
                    }
                } else if (this.finalObject.isWmall) {
                    if (this.showPackingCompleteButton) {
                        this.windowOpen(this.finalObject.invoiceLabel)
                    } else {
                        this.isLoading = true
                        let inputPayload = {
                            clientid: localStorage.getItem("selectedClient"),
                            warehouseid: localStorage.getItem("selectedWarehouse"),
                            orderid: this.finalObject.orderId,
                            shipmentid: this.finalObject.shipmentId,
                            saleschannel: this.finalObject.salesChannel //passed sales channel
                        }
                        let result = await packingApis.getUnicommerceInvoiceAndLabel(inputPayload, this.token)
                        if (result.data.data.ErrorCode == 0) {
                            this.windowOpen(result.data.data.data.data.invoicelabel)
                        } else {
                            this.$alert(result.data.data.msg)
                        }
                        this.isLoading = false
                    }
                } else if (this.finalObject.isNimbus ||(this.finalObject.invoiceLabel!=''&& this.finalObject.invoiceLabel!=null)) {
                    this.windowOpen(this.finalObject.invoiceLabel)
                } else if (this.finalObject.normalOrder==false && this.finalObject.showInvoiceButton==true) {
                   // alert("Hi")
                    this.printInvoiceWMS()
                } else if (this.finalObject.normalOrder) {
                    this.printInvoiceWMS()
                }
                else if (this.finalObject.isincreff) {
                    if (this.showPackingCompleteButton) {
                        this.windowOpen(this.finalObject.invoiceLabel)
                    }
                }
            } catch (err) {
                console.log(err)
                this.isLoading = false
            }
        },

        async printLabel() {
            try {
                if (this.finalObject.isRubicon) {
                    this.isLoading = true
                    let inputPayload = {
                        clientid: localStorage.getItem("selectedClient"),
                        shipmentid: this.finalObject.shipmentId,
                        orderid: this.finalObject.orderId,
                        sellername: this.finalObject.sellerName
                    }
                    let result = await packingApis.getrubiconInvoiceAndLabel(inputPayload, this.token)
                    if (result.data.data.ErrorCode == 0) {
                        if (result.data.data.data.shipping_label_document_external_url) {
                            this.windowOpen(result.data.data.data.shipping_label_document_external_url)
                        } else {
                            this.$alert(this.$t(`apiErrors.${result.data.data.errorLabel}`))
                        }
                    } else {
                        this.$alert(this.$t(`apiErrors.${result.data.data.errorLabel}`))
                    }
                    this.isLoading = false
                } else if (this.finalObject.isUnicommerce) {
                    if (this.showPackingCompleteButton) {
                        if(!this.finalObject.shippingLabel ){
                            this.$alert(this.invoiceFailureReason ? "Unable to retrieve the Uniware Label." + this.invoiceFailureReason : "Unable to retrieve the Uniware Label")
                            return false
                         }
                        this.windowOpen(this.finalObject.shippingLabel)
                    } else {
                        this.isLoading = true
                        let inputPayload = {
                            clientid: localStorage.getItem("selectedClient"),
                            warehouseid: localStorage.getItem("selectedWarehouse"),
                            orderid: this.finalObject.orderId,
                            shipmentid: this.finalObject.shipmentId,
                            ////passed sales channel
                            saleschannel: this.finalObject.salesChannel
                        }
                        let result = await packingApis.getUnicommerceInvoiceAndLabel(inputPayload, this.token)
                        if (result.data.data.ErrorCode == 0) {
                            this.windowOpen(result.data.data.data.data.shippinglabel)
                        } else {
                            this.$alert(result.data.data.msg)
                        }
                        this.isLoading = false
                    }
                } else if (this.finalObject.isMultiseller) {
                    if (this.showPackingCompleteButton) {
                        this.getInvoiceAndLabelFlipkart(2)
                    } else {
                        this.isLoading = true
                        let inputPayload = {
                            clientid: localStorage.getItem("selectedClient"),
                            warehouseid: localStorage.getItem("selectedClient"),
                            shipmentid: this.finalObject.shipmentId,
                            orderid: this.finalObject.orderId
                        }
                        let result = await packingApis.getFlipkartInvoiceAndLabel(inputPayload, this.token)
                        this.isLoading = false
                        if (result.data.data.ErrorCode == 0) {
                            this.finalObject.shippingLabel = result.data.data.data.data
                            this.finalObject.invoiceLabel = result.data.data.data.data
                            this.getInvoiceAndLabelFlipkart(2)
                        } else {
                            this.$alert(result.data.data.msg)
                        }
                    }
                } else if (this.finalObject.isWmall) {
                    if (this.showPackingCompleteButton) {
                        this.windowOpen(this.finalObject.shippingLabel)
                    } else {
                        this.isLoading = true
                        let inputPayload = {
                            clientid: localStorage.getItem("selectedClient"),
                            warehouseid: localStorage.getItem("selectedWarehouse"),
                            orderid: this.finalObject.orderId,
                            shipmentid: this.finalObject.shipmentId,
                            saleschannel: this.finalObject.salesChannel //passed sales channel
                        }
                        let result = await packingApis.getUnicommerceInvoiceAndLabel(inputPayload, this.token)
                        if (result.data.data.ErrorCode == 0) {
                            this.windowOpen(result.data.data.data.data.shippinglabel)
                        } else {
                            this.$alert(result.data.data.msg)
                        }
                        this.isLoading = false
                    }
                } else if (this.finalObject.isNimbus || (this.finalObject.shippingLabel!='' && this.finalObject.shippingLabel!=null)) {
                 
                        this.windowOpen(this.finalObject.shippingLabel)
                    
                } 
                else if (this.finalObject.xbEcomFlag) {
                    this.printLabelWMS()
                } else if (this.finalObject.normalOrder) {
                    this.printLabelWMS()
                }else if (this.finalObject.normalOrder==false && this.finalObject.showLabelButton==true) {
                    this.printLabelWMS()
                } else if (this.finalObject.isincreff) {
                    if (this.showPackingCompleteButton) {
                        this.windowOpen(this.finalObject.shippingLabel)
                    }
                }
            } catch (err) {
                console.log(err)
                this.isLoading = false
            }
        },

        async printInvoiceWMS() {
            try {
                // if(this.finalObject.awbNo=='' || this.finalObject.awbNo==null)
                // {
                //     this.$alert(this.$t('common.awbError'))
                //     return false;
                // }
                this.isLoading = true
                let inputPayload = {
                    clientid: localStorage.getItem("selectedClient"),
                    warehouseid: localStorage.getItem("selectedWarehouse"),
                    orderid: this.finalObject.orderId,
                    awbno: this.finalObject.awbNo,
                    shippingcompany: this.finalObject.courierName
                }
                let resultInvoiceWms = await packingApis.getInvoiceWMS(inputPayload, this.token)
                if (resultInvoiceWms.status) {
                    let invoiceData = resultInvoiceWms.data.printData.invoiceData.replace("/n", "")
                    var myWindow = window.open("", "MsgWindow", "_blank")
                    setTimeout(function () {
                        myWindow.document.write(invoiceData)
                    }, 2000)
                    myWindow.document.title = 'TaxInvoice'
                    setTimeout(function () {
                        myWindow.print()
                    }, 4000)
                } else {
                    this.$alert(this.$t('common.invoiceURLError'))
                }
                this.isLoading = false
            } catch (err) {
                console.log(err)
                this.isLoading = false
            }
        },

        getInvoiceAndLabelFlipkart(obj) { //stream object function
            let filename = this.finalObject.orderId + ".pdf"
            let data = ""
            if (obj == 1) {
                filename = "Invoice" + this.finalObject.orderId + ".pdf"
                data = this.finalObject.invoiceLabel
            } else {
                filename = "Label" + this.finalObject.orderId + ".pdf"
                data = this.finalObject.shippingLabel
            }
            let a = document.createElement("a");
            a.href = "data:application/octet-stream;base64," + data;
            a.download = filename
            a.click();
        },

        printLabelWMS() {
            if(this.finalObject.awbNo=='' || this.finalObject.awbNo==null)
            {
                this.$alert(this.$t('common.awbError'))
                return false;
            }
            

            let routeData = this.$router.resolve({
                name: 'shippinglabel',
                params: {
                    "clientid": localStorage.getItem("selectedClient"),
                    "warehouseid": localStorage.getItem("selectedWarehouse"),
                    "awbno": this.finalObject.awbNo,
                    "orderid": this.finalObject.orderId,
                    "shippingcompany": this.finalObject.courierName
                },
                query: {
                    clientid: this.finalObject.clientId,
                    warehouseid: localStorage.getItem("selectedWarehouse"),
                    awbno: this.finalObject.awbNo,
                    orderid: this.finalObject.orderId,
                    shippingcompany: this.finalObject.courierName,
                },
            })
            this.windowOpen(routeData.href)
        },

        windowOpen(obj) {
            window.open(obj, '_blank')
        },

        courierSelected() {
            if (this.finalObject.courierName && this.finalObject.courierName == 'Others') {
                this.$prompt(this.$t('packingb2b.b2bPacking.modal.enterCourierCompany')).then(text => {
                    if (text && text != '' && text != null) {
                        text = text.replace(/^.{1}/g, text[0].toUpperCase())
                        this.finalObject.salesChannelList.push({
                            'courierid': text.trim(),
                            'couriername': text.trim()
                        })
                        this.finalObject.courierName = text.trim()
                        this.$alert(this.$t('boxList.courierCompanyMsg1'), text)
                    } else {
                        this.$alert(this.$t('boxList.courierCompanyMsg2'), text)
                    }
                })
            }
        },


        async completeBoxPacking() {
            try {
                this.isLoadingFeild = true
                let inputPayload = {
                    clientid: localStorage.getItem("selectedClient"),
                    warehouseid: localStorage.getItem("selectedWarehouse"),
                    orderid: this.finalObject.orderId,
                    awbno: this.finalObject.awbNo,
                    shippingcompany: this.finalObject.courierName,
                    boxid: this.finalObject.boxId,
                    useremail: this.finalObject.userEmail,
                    userid: this.finalObject.userId,
                    boxweight: this.finalObject.boxWeight,
                    shippinglabel: this.finalObject.shippingLabel,
                    invoicelabel: this.finalObject.shippingLabel,
                    shippingcode: this.finalObject.shippingCode,
                    ordertype: this.finalObject.orderTypeInput,
                    saleschannel: this.finalObject.salesChannel,
                    xbecomflag: this.finalObject.xbEcomFlag,
                    shippingprovider: this.finalObject.shippingProviderFinal ? this.finalObject.shippingProviderFinal : '',
                }
                let resultCompleteBoxPacking = await packingApis.completeBoxPacking(inputPayload, this.token)
                if (resultCompleteBoxPacking.data.data.ErrorCode == 0) {
                    this.finalObject.boxStatus = 'in_shipping'
                    this.finalObject.orderStatus = 'packed'
                    this.showPackingCompleteButton = false
                    this.showBoxSuggestionSplit =false
                    this.showSplitBoxPacking=false
                    this.showQCAndPackingSection = false
                    this.showInvoiceAndLabels = true
                    this.$alertify.success(this.$t(`apiErrors.${resultCompleteBoxPacking.data.data.errorLabel}`))
                    this.finalBoxData=[],
                    this.isSuggestionPresent=false
                    this.resetForm();
                } else {
                    this.$alert(this.$t(`apiErrors.${resultCompleteBoxPacking.data.data.errorLabel}`), this.finalObject.boxId)
                }
                this.isLoadingFeild = false
            } catch (err) {
                console.log(err)
                this.isLoadingFeild = false
            }
        },

        splitBox() {
            if ((Number(this.finalObject.totalQty) - Number(this.finalObject.cancelQty) > 1) || this.finalObject.issplited) {
                this.showSplitBoxData = true
                this.destinationBoxId = ''
                this.destinationProductID = ''
                this.showSplitButton = false
                this.isBoxValid = false
                this.getSplitBoxDetails()
                var destinationBox = document.getElementById('destinationBoxId');
                if (destinationBox) {
                    destinationBox.disabled = false;
                }
                document.addEventListener('DOMContentLoaded', function() {
                    document.getElementById('destinationBoxId').value = null;
                  });
              } else {
                this.$alert(this.$t('boxList.boxSplitError'))
                return false
            }
        },

        async getSplitBoxDetails() {
            try {
                this.sourceBoxData = []
                this.destinationBoxData = []
                this.isLoadingFeild = true
                let inputPayload = {
                    clientid: localStorage.getItem("selectedClient"),
                    warehouseid: localStorage.getItem("selectedWarehouse"),
                    orderid: this.finalObject.orderId,
                }
                let resultSplitBoxDetails = await packingApis.getSplitBoxDetails(inputPayload, this.token)
                if (resultSplitBoxDetails.data.data.ErrorCode == 0) {
                    resultSplitBoxDetails.data.data.data.forEach((el) => {
                        if (el.boxid == this.finalObject.boxId) {
                            this.sourceBoxData.push(el)
                        }
                        else if(this.finalObject.issplited){
                            this.destinationBoxData.push(el)
                        }
                    })
                } else {
                    this.$alert(this.$t(`apiErrors.${resultSplitBoxDetails.data.data.errorLabel}`))
                }
                this.isLoadingFeild = false
            } catch (err) {
                console.log(err)
                this.isLoadingFeild = false
            }
        },

        
        async validateBox() {
            try {
                if (this.destinationBoxId < 1) {
                    this.$alert(this.$t('boxList.DestinationBoxiderr'), this.destinationBoxId)
                    return false
                }
                if (Number(this.destinationBoxId) == Number(this.finalObject.boxId)) {
                    this.$alert(this.$t('boxList.boxIDError'), this.destinationBoxId)
                    this.destinationBoxId = ''
                    document.getElementById('destinationBoxId').value = null
                    return false
                }
                this.isLoadingFeild = true
                let boxId = this.destinationBoxId
                let inputPayload = {
                    clientid: localStorage.getItem("selectedClient"),
                    warehouseid: localStorage.getItem("selectedWarehouse"),
                    orderid: this.finalObject.orderId,
                    boxid: this.destinationBoxId,
                    userid: this.finalObject.userId,
                    shipmentid: this.finalObject.shipmentId,
                    itemid:''
                }
                let resultValidateBox = await packingApis.validateBox(inputPayload, this.token)
                if (resultValidateBox.data.data[0].ErrorCode == 0 && resultValidateBox.data.data[0].data) {
                    this.$alertify.success(this.$t(resultValidateBox.data.data[0].msg))
                    this.isBoxValid = true;
                    document.getElementById('destinationBoxId').disabled = true
                    document.getElementById('destinationBoxId1').disabled = true
                    this.showSplitButton = true
                } else {
                    this.isBoxValid = false;
                    this.destinationBoxId = ''
                    this.showSplitButton = false
                    document.getElementById('destinationBoxId').value = null
                    let errMessage = resultValidateBox.data.data[0].errorLabel
                    const str = errMessage.split(/[{}]/)
                        .map(part => (!this.$t(`apiErrors.${part}`) || this.$t(`apiErrors.${part}`).startsWith("apiErrors")) ? part : this.$t(`apiErrors.${part}`))
                        .join(" ");
                    this.$alert(str!=''?str:response.data.data.msg, boxId)
                }
                this.isLoadingFeild = false
            } catch (err) {
                console.log(err)
                this.isLoadingFeild = false
            }
        },
        getSpecialInstructionModal(){
            this.specialInstructionModel=true;
        },
        async getSpecialInstruction(){
            var userToken = window.localStorage.getItem('userToken');
            var myStr = userToken.replace(/"/g, '');
            this.isLoading=true;
            await axios({
              method: 'POST',
              'url': apiUrl.api_url + 'getSpecialPackingInstruction',
              'data': {
                    clientid: window.localStorage.getItem('selectedClient'),
                    saleschannel:this.finalObject.salesChannel
                },
              headers: {
                'Authorization': 'Bearer ' + myStr,
              },
               })
               .then((response) => {
                this.specialInstructionList = Array.isArray(response.data.data.data) ? response.data.data.data : [];
                this.specialInstructionCount=this.specialInstructionList.length;
                if(this.specialInstructionCount>0){
                    this.specialInstructionButton=true;
                }else{
                    this.specialInstructionButton=false;
                }
                this.isLoading=false;
               })
               .catch((httpException) => {
                 console.error('exception is:::::::::', httpException)
               }); 
         },
        closeSpecialInstructionModal(){
            this.specialInstructionModel=false;
        },
        showAlert() {
            this.$alert(this.$t("bundlePacking.showAlert"));
        },
        showCreateBundleModal(){
           this.createBundleModel=true;
           this.getBundleBoxProduct()
        },
        closeCreateBundleModal(){
            this.createBundleModel=false;
        },
        radioToggleSection(data) {
            this.selectedBundleSKU = this.selectedBundleSKU === data.productid ? null : data.productid;
            this.bundleproductid=data.productid;
            this.bundleitemid=data.bundleitemid
            this.getBundleBoxProduct(this.bundleproductid,this.bundleitemid)
          },
        
        async getBundleBoxProduct(bundleproductid='',bundleitemid=''){
            var userToken = window.localStorage.getItem('userToken');
            var myStr = userToken.replace(/"/g, '');
            this.isLoadingPacking = true;
            this.input=({
                clientid:window.localStorage.getItem("selectedClient"),
                warehouseid:window.localStorage.getItem("selectedWarehouse"),
                orderid:this.finalObject.orderId,
                boxid:this.finalObject.boxId,
                bundleproductid:bundleproductid,
                bundleitemid:bundleitemid
            })
            await axios({
                method: 'POST',
                'url': apiUrl.api_url + 'getBundleBoxProduct',
                'data':this.input,
                headers: {
                  'Authorization': 'Bearer ' + myStr,
                },
            })
            .then((response) => {
               if(bundleproductid==''&& bundleitemid==''){
                this.bundleSKUData=response.data.data
               }else{
                this.bundleSKUBOMData=response.data.data
               }
               this.isLoadingPacking = false;
            })
            .catch((httpException) => {
                console.error('exception is:::::::::', httpException)
            }); 
        },
       async scanChildSKUFunc(){
            var userToken = window.localStorage.getItem('userToken');
            var myStr = userToken.replace(/"/g, '');
            this.isLoadingPacking = true;
            this.input=({
                clientid:window.localStorage.getItem("selectedClient"),
                warehouseid:window.localStorage.getItem("selectedWarehouse"),
                orderid:this.finalObject.orderId,
                boxid:this.finalObject.boxId,
                bundleproductid:this.bundleproductid,
                bundleitemid:this.bundleitemid,
                childsku:this.scanChildSku,
                qty:1,
                useremail:this.finalObject.userEmail
            })
            await axios({
                method: 'POST',
                'url': apiUrl.api_url + 'validateProductAndCreateBundle',
                'data':this.input,
                headers: {
                  'Authorization': 'Bearer ' + myStr,
                },
            })
            .then((response) => {
                if(response.data.status){
                    this.scanChildSuccess=true 
                    let clientProductArray=response.data.data
                    let filteredClientProductArray=clientProductArray.filter(item => item.eancode == this.scanChildSku || item.productid==this.scanChildSku)
                    this.bundleChildEanCode=filteredClientProductArray[0].eancode
                    this.bundleChildProductName=filteredClientProductArray[0].productname
                    this.scanChildClientProductId=filteredClientProductArray[0].clientproductid
                    this.scanBundleChildImage=filteredClientProductArray[0].productimage
                    this.scanTxnqty=filteredClientProductArray[0].txnqty
                    this.scanChildSku=''
                    this.updateBundleSKUBOMData(this.scanChildClientProductId,this.scanTxnqty)
                    this.$alertify.success(response.data.msg)
                }else{
                    this.scanChildSuccess=false
                    this.$alertify.error(response.data.msg) 
                }
                this.isLoadingPacking = false;

            })
            .catch((httpException) => {
                console.error('exception is:::::::::', httpException)
            }); 
        },
        updateBundleSKUBOMData(scanChildClientProductId,scanTxnqty){
            const matchedItem = this.bundleSKUBOMData.find(
                (item) => item.clientproductid === scanChildClientProductId
            );
            if (matchedItem) {
                matchedItem.bundlescan = scanTxnqty;
            }
        },
        cancelSelectedBundleSKU(){
          this.selectedBundleSKU=null
        },
        async printproduct() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var clientdata =window.localStorage.getItem('clientList')
			var bytes = CryptoJS.AES.decrypt(clientdata.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var decryptClientList = JSON.parse(plaintext);	
			var clientname=decryptClientList.filter(ele=>ele.clientid == this.clientid)	
            this.isLoadingPacking = true;
			this.input = ({
				clientname: clientname[0].clientname,
				Eancode:this.bundleChildEanCode,
				productname:this.bundleChildProductName,
				qty: Number("1")
			});
			await axios({
					method: 'POST',
					'url': apiUrl.api_url +'generateProductBarcode',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					},
					responseType:"blob"
				})
				.then(result => {
					if (result.data) {
						const file = new Blob([result.data], { type: "application/pdf" });
						//Build a URL from the file
						const fileURL = URL.createObjectURL(file);
						//Open the URL on new Window
						 const pdfWindow = window.open();
						 pdfWindow.location.href = fileURL;
						this.$alertify.success(this.$t('editedjson.printSuccess'));
					}
                    this.isLoadingPacking = false;
                    this.getBundleBoxProduct();
                    this.getBoxDetails(0);
				}, error => {
					this.isLoading = false;
					console.error(error)
				})
		},
        resetBoxData(){
             this.destinationBoxId = '';
             this.finalObject.productId='';
             this.productDetails=false;
             this.isBoxValid = false;

                document.getElementById('destinationBoxId').value = null;
                document.getElementById('destinationBoxId1').value = null;
                document.getElementById('destinationBoxId').disabled = false;
                document.getElementById('destinationBoxId1').disabled = false;

        },

        async splitBoxProducts() {
            try {
                this.isLoadingFeild = true
                let inputPayload = {
                    clientid: localStorage.getItem("selectedClient"),
                    warehouseid: localStorage.getItem("selectedWarehouse"),
                    orderid: this.finalObject.orderId,
                    newboxid: this.destinationBoxId,
                    userid: this.finalObject.userId,
                    shipmentid: this.finalObject.shipmentId,
                    boxid: this.finalObject.boxId,
                    productid: this.destinationProductID,
                    useremail: this.finalObject.userEmail,
                }
                let resultSplitBoxPacking = await packingApis.splitBoxPacking(inputPayload, this.token)
                if (resultSplitBoxPacking.data.data[0].ErrorCode == 0) {
                    this.$alertify.success(this.$t(`apiErrors.${resultSplitBoxPacking.data.data[0].errorLabel}`))
                    this.getBoxDetails(this.initiatecall)
                } else {
                    this.$alert(this.$t(`apiErrors.${resultSplitBoxPacking.data.data[0].errorLabel}`), this.destinationProductID)
                    this.destinationProductID = ''
                    document.getElementById('destinationProductID').value = null
                }
                this.isLoadingFeild = false
            } catch (err) {
                console.log(err)
                this.isLoadingFeild = false
            }
        },

    }
}



// WEBPACK FOOTER //
// ./src/views/components/packingb2c/packingnew.component.js